import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'

export interface StadiumEventsResponse {
  stadium_events: [
    { event_type: 'spelling'; count: number },
    { event_type: 'grammar'; count: number },
    { event_type: 'vocabulary'; count: number },
    { event_type: 'usage'; count: number },
  ]
}

export interface StadiumEventsData {
  spelling: number
  grammar: number
  vocabulary: number
  usage: number
}

export async function stadiumEvents(
  this: StudentEventsService,
  product: LegacyProductRex,
  scope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<StadiumEventsData>> {
  if (isEmpty(scope.ids)) return null

  const url = this.buildUrl('stadium_events', product, scope)
  const query = this.buildQuery(scope, period)

  const data = await this.fetchData<StadiumEventsResponse>(url, query)
  if (!data) return null

  const { stadium_events } = data
  if (stadium_events.length !== 4) return null

  const spelling = stadium_events.find((e) => e.event_type === 'spelling')?.count ?? 0
  const grammar = stadium_events.find((e) => e.event_type === 'grammar')?.count ?? 0
  const vocabulary = stadium_events.find((e) => e.event_type === 'vocabulary')?.count ?? 0
  const usage = stadium_events.find((e) => e.event_type === 'usage')?.count ?? 0
  if (spelling === 0 && grammar === 0 && vocabulary === 0 && usage === 0) return null

  return {
    spelling,
    grammar,
    vocabulary,
    usage,
  }
}
